import { render } from "./Drive.vue?vue&type=template&id=07df167e&scoped=true&ts=true"
import script from "./Drive.vue?vue&type=script&lang=ts"
export * from "./Drive.vue?vue&type=script&lang=ts"

import "./Drive.vue?vue&type=style&index=0&id=07df167e&scoped=true&lang=sass"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07df167e"]])

export default __exports__